import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=7e005732&scoped=true&lang=pug&"
import script from "./BaseLink.vue?vue&type=script&lang=js&"
export * from "./BaseLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=7e005732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e005732",
  null
  
)

export default component.exports